module.exports = __webpack_public_path__ + "static/q7answer4_garden_wishmas-b394422f61f73d450b0a36642e0dbf8e.jpg";